'use es6';

import * as collect from './collect';
import * as hydrate from './hydrate';
export const get = (spec, config, module) => {
  const collectFn = collect.get(spec, config, module);
  const hydrateFn = hydrate.get(spec, config);
  return data => collectFn(data).then(dataWithReferences => hydrateFn(dataWithReferences));
};